import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'microsoft-sharepoint',
  name: 'Microsoft SharePoint',
  category: 'integrations',
  description: 'Interact with Microsoft SharePoint via Microsoft Graph API. Manage sites, lists, list items, files, and folders.',
  icon: 'microsoft-sharepoint',
  iconType: 'microsoft-icon',
  color: 'teal',
  version: '1.0.0',
  group: ['transform'],
  defaults: {
    name: 'Microsoft SharePoint',
    color: '#038387',
  },
  credentials: [
    {
      name: 'microsoft_sharepoint_oauth',
      required: true,
      displayName: 'Microsoft SharePoint OAuth2',
      displayOptions: {
        show: {
          useCredential: [true],
        },
      },
    },
  ],
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['microsoft', 'sharepoint', 'ecm', 'document', 'list', 'site', 'collaboration', 'microsoft-graph', 'files', 'folders'],
  comingSoon: false,
};

export default definition;
